"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateVerifiedNurseLicenseDto = instanceOfCreateVerifiedNurseLicenseDto;
exports.CreateVerifiedNurseLicenseDtoFromJSON = CreateVerifiedNurseLicenseDtoFromJSON;
exports.CreateVerifiedNurseLicenseDtoFromJSONTyped = CreateVerifiedNurseLicenseDtoFromJSONTyped;
exports.CreateVerifiedNurseLicenseDtoToJSON = CreateVerifiedNurseLicenseDtoToJSON;
exports.CreateVerifiedNurseLicenseDtoToJSONTyped = CreateVerifiedNurseLicenseDtoToJSONTyped;
const JurisdictionAbbreviation_1 = require("./JurisdictionAbbreviation");
const CompactStatus_1 = require("./CompactStatus");
const LicenseType_1 = require("./LicenseType");
/**
 * Check if a given object implements the CreateVerifiedNurseLicenseDto interface.
 */
function instanceOfCreateVerifiedNurseLicenseDto(value) {
    if (!('expirationDate' in value) || value['expirationDate'] === undefined)
        return false;
    if (!('compactStatus' in value) || value['compactStatus'] === undefined)
        return false;
    if (!('jurisdiction' in value) || value['jurisdiction'] === undefined)
        return false;
    if (!('licenseNumber' in value) || value['licenseNumber'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    return true;
}
function CreateVerifiedNurseLicenseDtoFromJSON(json) {
    return CreateVerifiedNurseLicenseDtoFromJSONTyped(json, false);
}
function CreateVerifiedNurseLicenseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'expirationDate': (new Date(json['expirationDate'])),
        'compactStatus': (0, CompactStatus_1.CompactStatusFromJSON)(json['compactStatus']),
        'jurisdiction': (0, JurisdictionAbbreviation_1.JurisdictionAbbreviationFromJSON)(json['jurisdiction']),
        'licenseNumber': json['licenseNumber'],
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
    };
}
function CreateVerifiedNurseLicenseDtoToJSON(json) {
    return CreateVerifiedNurseLicenseDtoToJSONTyped(json, false);
}
function CreateVerifiedNurseLicenseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'expirationDate': ((value['expirationDate']).toISOString().substring(0, 10)),
        'compactStatus': (0, CompactStatus_1.CompactStatusToJSON)(value['compactStatus']),
        'jurisdiction': (0, JurisdictionAbbreviation_1.JurisdictionAbbreviationToJSON)(value['jurisdiction']),
        'licenseNumber': value['licenseNumber'],
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
    };
}
//# sourceMappingURL=CreateVerifiedNurseLicenseDto.js.map